import { Context } from "Context";
import { useContext, Fragment } from "react";
import { getCdn } from "utils";
import appConfig from "config.json";

import Link from "components/shared/Link";

const { brands } = appConfig;
const syndicatedCdn = getCdn();
const syndicatedNavigationClass = "syndicated-navigation";
const syndicatedNavigationNavClass = `${syndicatedNavigationClass}__nav`;

const Logo = ({ onLoadCallback = null, moveLeft = false }) => {
	const {
		config: {
			basePath,
			brand,
			locale,
			logo,
			logoRedirect,
			overrideLogo,
			store,
			defaultLocale,
			absoluteLinksFromBrand,
		},
		headerData: { logo: cmsLogo },
	} = useContext(Context);

	const brandLogoSrc = overrideLogo
		? `${syndicatedCdn}/logos/${overrideLogo}.svg`
		: cmsLogo?.image?.url ||
		  `${syndicatedCdn}/logos/${brands[brand].logo || `${brand}.svg`}`;

	const brandLogo = (
		<img
			src={brandLogoSrc}
			alt={`${brands[brand]?.name} Logo`}
			loading="eager"
			decoding="async"
			onLoad={onLoadCallback}
		/>
	);
	const brandLogoClasses = `${syndicatedNavigationNavClass}__logo ${syndicatedNavigationNavClass}__logo--${brand} ${syndicatedNavigationNavClass}__logo--${brand}--${locale}${
		logo ? "" : ` ${syndicatedNavigationNavClass}__logo--hide`
	}${moveLeft ? ` ${syndicatedNavigationNavClass}__logo--move-left` : ""}`;

	const determineHref = () => {
		const currentLocalePath = locale !== defaultLocale ? `/${locale}` : "";
		const defaultHref = `${window.location.origin}${basePath}${
			basePath ? "/" : ""
		}`;
		if (absoluteLinksFromBrand) return basePath;
		if (brands[brand]?.preventLocalizeLogo) return defaultHref;
		const logoRedirectUrl = brands[brand]?.logoRedirectUrl || "";
		const shouldLocalizeUrls = brands[brand]?.shouldLocalizeUrls !== false;
		const cmsLink = cmsLogo?.webLinks?.[0]?.href;
		if (cmsLink && cmsLink !== "/" && !cmsLink.startsWith("http")) {
			return `${cmsLink}`;
		}
		if (logoRedirectUrl || !shouldLocalizeUrls) {
			const brandPath = logoRedirectUrl ? `${logoRedirectUrl}/` : "";
			return `${defaultHref}${currentLocalePath}/${brandPath}`;
		}
		return defaultHref;
	};

	const renderBrandLogo = () => {
		return !logoRedirect || store ? (
			<div
				className={`${brandLogoClasses} ${syndicatedNavigationNavClass}__logo--no-pointer`}
			>
				{brandLogo}
			</div>
		) : (
			<Link
				href={determineHref()}
				className={brandLogoClasses}
				ariaLabel={`${brands[brand]?.name} Logo`}
			>
				{brandLogo}
			</Link>
		);
	};

	return (
		<Fragment>
			{renderBrandLogo()}
			<div id="logoSchema" itemType="http://schema.org/Organization">
				<link itemProp="url" href={window.location.origin} />
				<link itemProp="logo" href={brandLogoSrc} />
			</div>
		</Fragment>
	);
};

export default Logo;
